<template>
    <div class="dashboard-page">
        <div class="dashboard-header">
            <span class="greeting-text locale-font">{{ greetingText }}</span>
            <span class="datetime-text locale-font">{{ datetimeText }}</span>
            <AttendanceSummaryList ref="summary" />
        </div>

        <div class="dashboard-container">
            <div class="graph-employee-late-absent">
                <EmployeeStatusGraph ref="statusGraph" />
            </div>
            <div class="graph-average-time">
                <AverageCheckInGraph ref="averageGraph" />
            </div>
            <div class="employee-onsite-today">
                <OnsiteTodayTable ref="onsite" />
            </div>
        </div>
    </div>
</template>

<script>
import AttendanceSummaryList from '@/components/Dashboard/AttendanceSummaryList'
import AverageCheckInGraph from '@/components/Dashboard/AverageCheckInGraph'
import EmployeeStatusGraph from '@/components/Dashboard/EmployeeStatusGraph'
import OnsiteTodayTable from '@/components/Dashboard/OnsiteTodayTable'

export default {
    name: 'Dashboard',

    components: {
        AttendanceSummaryList,
        AverageCheckInGraph,
        EmployeeStatusGraph,
        OnsiteTodayTable
    },

    data () {
        return {
            currentTime: new Date(),
            dataLoading: false
        }
    },

    computed: {
        greetingText () {
            const currentHours = this.currentTime.getHours()
            let greetingText = this.$vuetify.lang.t('$vuetify.dashboard.goodEvening')
            if (currentHours < 12) {
                greetingText = this.$vuetify.lang.t('$vuetify.dashboard.goodMorning')
            } else if (currentHours < 18) {
                greetingText = this.$vuetify.lang.t('$vuetify.dashboard.goodAfternoon')
            }
            return `${greetingText}, `.toUpperCase()
        },

        datetimeText () {
            const currentHours = this.currentTime.getHours().toString().padStart(2, '0')
            const currentMinutes = this.currentTime.getMinutes().toString().padStart(2, '0')
            const dateText = this.$dateUtil.dateToDateString(this.currentTime, this.$vuetify.lang.current)
            return `${dateText} : ${currentHours}.${currentMinutes}`
        }
    },

    methods: {
        startDashboardInterval () {
            this.stopDashboardInterval()

            const self = this
            window.dashboardInterval = setInterval(() => {
                if (!self) {
                    clearInterval(window.dashboardInterval)
                }

                self.currentTime = new Date()
            }, 200)
        },

        stopDashboardInterval () {
            if (window.dashboardInterval) {
                clearInterval(window.dashboardInterval)
            }
        },

        async getData () {
            if (this.dataLoading) {
                return
            }

            this.dataLoading = true
            this.$store.dispatch('setLoading', true)
            const summary = await this.$refs.summary.getData()
            await this.$refs.statusGraph.getData(summary.total)
            await this.$refs.averageGraph.getData()
            await this.$refs.onsite.getData()
            this.dataLoading = false
            this.$store.dispatch('setLoading', false)
        }
    },

    created () {
        this.startDashboardInterval()
    },

    async mounted () {
        await this.getData()
    },

    beforeDestroy () {
        this.stopDashboardInterval()
    },

    watch: {
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                await this.getData()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.dashboard-page {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}
.dashboard-header {
    .greeting-text {
        font-size: 32px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.25;
        letter-spacing: normal;
        color: black;
    }
    .datetime-text {
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.28;
        letter-spacing: normal;
        color: black;
    }
}
.dashboard-container {
    display: grid;
    width: 100%;
    margin-bottom: 2rem;
    grid-auto-rows: 1fr;
    grid-gap: 30px;
    grid-template-columns: calc(50% - 20px) calc(50% - 20px);
    color: #444;

    .employee-onsite-today {
        grid-column: 1 / span 2;
        grid-row: 2 / 2;
    }
    .graph-employee-late-absent {
        grid-column: 1;
        grid-row: 1 / 1;
    }
    .graph-average-time {
        grid-column: 2;
        grid-row: 1 / 1;
    }
}
</style>
